<div class="main-content">
  <div class="pr-2">
    <button (click)="cerrar();" type="button" class="close pt-2 z-3" style="position: relative;" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
    <div class="d-flex justify-content-center">
    <h2 mat-dialog-title>Contact History</h2>
    </div>
  <mat-dialog-content>

    <section class="">
      <!-- TABLE -->
      <div *ngIf="this.userinterno !== undefined" style="margin-top: 32px">

        <!-- TODO: IMPLEMENTS TABLE DINAMIC -->
        <dinamic-table
          *ngIf="!loading"
          [id]="'contactHistoryTable'"
          [data]="contacts"
          [perPage]="itemsPorPagina"
          [page]="paginaActual"
          [total_items_count]="totalItems"
          [total_pages]="totalPaginas"
          (buscar)="getAllContacts($event,false)"
          (action_button)="action($event)"
          [btnExcel]="btns"
          [btnPDF]="btns"
          [btnPrint]="btns"
          [btnCol]="btns"
          [search]="btns"
          [btnOrd] = "btns"
        ></dinamic-table>

        <!-- TABLA ANTERIOR -->
        <!--<div class="material-datatables" *ngIf="tableDinamic">
          <table id="datatables1" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
            style="width: 100%">
            <thead>
              <tr>
                <th>{{ tableContacts.headerRow[0] }}</th>
                <th class="text-center">
                  {{ tableContacts.headerRow[1] }}
                </th>
                <th class="text-center">
                  {{ tableContacts.headerRow[2] }}
                </th>
                <th class="text-center">
                  {{ tableContacts.headerRow[3] }}
                </th>
                <th class="text-center">
                  {{ tableContacts.headerRow[4] }}
                </th>
                <th class="disabled-sorting text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr id="contacthistoryregistry{{row[0]}}" *ngFor="let row of tableContacts.dataRows">
                <td>{{row[0]}}</td>
                <td class="text-center">{{row[1]}}</td>
                <td class="text-center">
                  {{row[2] * 1000 | date:'MM-dd-yyyy'}}
                </td>
                <td class="text-center">
                  {{row[3] * 1000 | date:'MM-dd-yyyy'}}
                </td>
                <td class="text-center">{{row[4]}}</td>
                <td class="text-right">
                  <a (click)="getContactHistory(row[0])" class="btn btn-link btn-warning btn-just-icon" title="Edit"><i
                      class="material-icons">edit</i></a>
                  <a (click)="deleteContactHistory(row[0])" class="btn btn-link btn-danger btn-just-icon"
                    title="Delete"><i class="material-icons">delete_forever</i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>-->
  
      </div>
  
      <section>
        <button class="gts-btn-primary-basic" matRipple (click)="showFormContactH('New')" [disabled]="titleFormContactHistory==='Edit'">
          <span class="gts-btn-icon-left" *ngIf="!showFormContactHistory">add</span>
          <span class="gts-btn-icon-left" *ngIf="showFormContactHistory">remove</span>
          <span class="gts-btn-text">{{titleFormContactHistory}} Contact History</span>
        </button>
      </section>
  
      <!-- FORM -->
  
  
      <section *ngIf="this.userinterno !== undefined && showFormContactHistory">
        <section class="layout-form-x4" style="padding-top: 16px">
          <mat-form-field class="example-full-width">
            <mat-label>Purchasing REP</mat-label>
            <input matInput type="text" name="Purchasing REP" value="{{identity.name}} {{identity.surname}}" disabled />
          </mat-form-field>
  
          <mat-form-field class="example-full-width">
            <mat-label>Contact Date</mat-label>
            <input matInput [matDatepickerFilter]="dateFilter" [matDatepicker]="contactDate" name="Contact Date"
              [(ngModel)]="contacthistory.fechacontacto" />
            <mat-datepicker-toggle matIconSuffix [for]="contactDate"></mat-datepicker-toggle>
            <mat-datepicker #contactDate></mat-datepicker>
          </mat-form-field>
  
          <div>
            <p style="margin: 0px; height: 20px; color: black; font-size: 13px; ">Contact Hour</p>
            <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="horacontacto"
              [(ngModel)]="contacthistory.horacontacto" />
          </div>
  
          <mat-form-field appearance="fill">
            <mat-label>Send a Reminder?</mat-label>
            <select name="reminder" id="reminder" [(ngModel)]="contacthistory.reminder" required matNativeControl>
              <option value="null" disabled>
                Please select an option
              </option>
              <option value="YES">Yes</option>
              <option value="NO">No</option>
            </select>
          </mat-form-field>
        </section>
  
        <section class="layout-form-x4" style="padding-top: 16px" *ngIf="contacthistory.reminder == 'YES'">
  
          <mat-form-field class="example-full-width">
            <mat-label>Reminder Date</mat-label>
            <input matInput [matDatepicker]="reminderDate" [(ngModel)]="contacthistory.fecha" />
            <mat-datepicker-toggle matIconSuffix [for]="reminderDate"></mat-datepicker-toggle>
            <mat-datepicker #reminderDate></mat-datepicker>
          </mat-form-field>
  
          <div class="">
            <p style="margin: 0px; height: 20px; color: black; font-size: 13px; ">Reminder Hour</p>
            <input type="time" class="form-control" min="00:00:00" max="23:59:00" name="hora" #hora="ngModel"
              [(ngModel)]="contacthistory.hora" />
          </div>
  
          <div class="form-group">
            <mat-checkbox class="check-margin" name="email" [(ngModel)]="contacthistory.email">
              Email
            </mat-checkbox>
          </div>
  
          <div class="form-group">
            <mat-checkbox class="check-margin" name="notification" [(ngModel)]="contacthistory.notification">
              Notification
            </mat-checkbox>
          </div>
  
        </section>
  
        <mat-form-field>
          <mat-label>Things to remember</mat-label>
          <textarea matInput placeholder="Things to remember..." name="descripcion" #descripcion="ngModel"
            [(ngModel)]="contacthistory.descripcion" class="form-control" rows="4"></textarea>
        </mat-form-field>
  
        <!-- <button type="button" class="btn btn-primary" (click)="openUsersModal();" *ngIf="contacthistory.reminder == 'YES'">
              Add people to reminder
            </button> -->
  
  
        <section>
          <button class="gts-btn-primary-basic" matRipple (click)="showAddPeopleToReminder = !showAddPeopleToReminder" *ngIf="contacthistory.reminder == 'YES'">
            <span class="gts-btn-icon-left" *ngIf="!showAddPeopleToReminder">add</span>
            <span class="gts-btn-icon-left" *ngIf="showAddPeopleToReminder">remove</span>
            <span class="gts-btn-text">Add people to reminder</span>
          </button>
        </section>
  
        <section *ngIf="showAddPeopleToReminder" style="background-color: rgb(245, 245, 245); margin-top: 16px;">
  
          <div class="modal-body">
            <div class="add-people-search">
              <mat-form-field class="example-full-width">
                <input matInput [formControl]="myControlUsers" placeholder="Search" type="text" />
              </mat-form-field>
            </div>
            <div class="col-md-12">
            <section class="scroll">
              <div *ngFor="let item of filteredArrayUsers | async" class="row notify">
                  <div (click)="seleccionarUser(item.id)">
                      <a class="btn btn-link btn-primary btn-just-icon">
                        <i class="material-icons">{{chequeadoUser(item.id) ? 'check_box' :
                          'check_box_outline_blank'}}</i>
                      </a>
                      <span>{{item.name | titlecase }} {{item.surname}}</span>
                  </div>
              </div>
            </section>
            </div>
          </div>
  
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-danger" (click)="closeUsersModal(1)">
              Close
            </button>
            &nbsp;&nbsp;
            <button type="button" class="btn btn-primary" (click)="closeUsersModal(2)">
              Save
            </button>
          </div> -->
  
        </section>
  
  
  
        <section class="container-buttons-right" *ngIf="this.userinterno !== undefined && editHistory" style="margin: 16px 0px;">
          <button class="gts-btn-primary-outline" matRipple (click)="cleanContact()">
            <!-- <span class="gts-btn-icon-left">cancel</span> -->
            <span class="gts-btn-text">Cancel</span>
          </button>
  
          <button class="gts-btn-primary" matRipple (click)="editContactHistory()"
            [disabled]="!contacthistory.reminder">
            <!-- <span class="gts-btn-icon-left">save</span> -->
            <span class="gts-btn-text">Save changes</span>
          </button>
  
        </section>
  
  
        <section class="container-buttons-right" *ngIf="this.userinterno !== undefined && !editHistory" style="margin: 16px 0px;">
  
          <button class="gts-btn-primary-outline" matRipple (click)="cleanContact()">
            <!-- <span class="gts-btn-icon-left">cancel</span> -->
            <span class="gts-btn-text">Cancel</span>
          </button>
  
          <button class="gts-btn-primary" matRipple (click)="onSubmit()"
            [disabled]="!contacthistory.reminder">
            <!-- <span class="gts-btn-icon-left">add</span> -->
            <span class="gts-btn-text">Contact History</span>
          </button>
  
        </section>
  
  
      </section>
  
    </section>
  

</mat-dialog-content>
</div>